import { HTMLAttributes, forwardRef } from 'react';
import { BUNU_TERMS_OF_USE, TOLSTOY_PRIVACY_POLICY } from '@/constants/links';

interface TermsAndConditionsProps extends HTMLAttributes<HTMLDivElement> {}

const TermsAndConditions = forwardRef<HTMLDivElement, TermsAndConditionsProps>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={`text-sm ${className}`} {...props}>
      <span>By continuing, you agree to Tolstoy’s </span>
      <a
        className="whitespace-nowrap underline"
        href={BUNU_TERMS_OF_USE}
        target="_blank"
        rel="noreferrer"
      >
        Terms of Use
      </a>
      <span> and confirm that you have read Tolstoy’s </span>
      <a
        className="whitespace-nowrap underline"
        href={TOLSTOY_PRIVACY_POLICY}
        target="_blank"
        rel="noreferrer"
      >
        Privacy Policy
      </a>
      <span>.</span>
    </div>
  )
);

TermsAndConditions.displayName = 'TermsAndConditions';

export default TermsAndConditions;
